import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from '..';

const useStyles = buildUseStyles('PreformattedText', () => ({
  pre: {
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
  },
}));

const PreformattedText = ({ className, ...props }) => {
  const classes = useStyles();

  return (
    <Text
      {...props}
      className={classNames(className, classes.pre)}
      component="pre"
    />
  );
};

PreformattedText.defaultProps = {
  className: '',
};

PreformattedText.propTypes = {
  className: PropTypes.string,
};

export default PreformattedText;
